module.exports = __webpack_public_path__ + "img/arh_9.c64671c1.png";